import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getCombinationArticleData } from "../services/articles.service";
import { fetchItemsInfoFromDataService } from "../services/localCombination.service";
import { QueryKeys } from "./queryKeys";

export const useCombinationArticleData = (
  subArticleId: string | undefined,
  isEnabled: boolean = false
) => {
  return useQuery({
    queryKey: [QueryKeys.CombinationArticle, subArticleId],
    queryFn: () => getCombinationArticleData(subArticleId || ""),
    enabled: !!subArticleId && isEnabled,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours cache time
    staleTime: 1000 * 60 * 60 * 24, // 24 hours stale time
  });
};

export const useCombinationArticle = (
  storeId: string,
  countryId: string,
  articleIds: string,
  options?: Omit<UseQueryOptions, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: [QueryKeys.CombinationArticle, countryId, storeId, articleIds],
    queryFn: () =>
      fetchItemsInfoFromDataService(storeId, countryId, articleIds),
    enabled: !!articleIds && options?.enabled !== false,
    ...options,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours cache time
    staleTime: 1000 * 60 * 60 * 24, // 24 hours stale time
  });
};
